Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _FontSize = require("../../styles/STYLES/FontSize");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    COLORS = _STYLES$useStyles.COLORS,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    viewports = _STYLES$useStyles.viewports;
  var achievementGroup = {
    alignItems: 'center'
  };
  var imageContainer = {
    alignItems: 'center',
    justifyContent: 'center',
    maxHeight: '100%',
    maxWidth: '100%'
  };
  var image = {
    height: '100%',
    width: '100%'
  };
  var achievementContainerValue = {
    marginTop: spacing.xxs,
    marginBottom: spacing.xxs
  };
  var achievementLabelContainer = {
    marginBottom: spacing.l,
    textAlign: 'center'
  };
  var achievementLabel = Object.assign({
    fontSize: _FontSize.fontSize.normal,
    lineHeight: _FontSize.lineHeight.normal
  }, fontSemiBold, {
    color: COLORS.aubergine
  });
  if (bp.gt(viewports.mobile_normal)) {
    achievementGroup.width = '50%';
  }
  if (bp.gt(viewports.mobile_l)) {
    achievementLabelContainer.marginBottom = 0;
    achievementGroup.padding = spacing.l;
  }
  if (bp.gt(viewports.tablet)) {
    achievementGroup.width = 210;
  }
  var styles = _reactNative.StyleSheet.create({
    achievementContainerValue: achievementContainerValue,
    achievementGroup: achievementGroup,
    achievementLabel: achievementLabel,
    achievementLabelContainer: achievementLabelContainer,
    imageContainer: imageContainer,
    image: image
  });
  return {
    styles: styles
  };
};